export function url(strings: string[] | TemplateStringsArray, ...values: string[]): string {
	let result = "";

	for (let i = 0; i < strings.length; i++) {
		result += strings[i];

		if (i < values.length) {
			result += encodeURIComponent(values[i]);
		}
	}

	return result;
}
export function mapToQuery(queries: Map<string, any>): string {
	return [...queries.entries()]
		.map(([name, value]) => {
			if (value === null || value === undefined) return "";
			if (Array.isArray(value)) return arrayToQuery(value, name);
			if (value instanceof Set) return setToQuery(value, name);
			return name + "=" + encodeURIComponent(value.toString());
		})
		.filter((it) => it.length)
		.join("&");
}
export function arrayToQuery(array: Array<string>, name: string) {
	if (array.length === 0) {
		return "";
	}

	const result: Array<string> = [];
	array.forEach((val) => {
		result.push(name + "=" + encodeURIComponent(val.toString()));
	});
	return result.join("&");
}
export function setToQuery(set: Set<string>, name: string): string {
	return arrayToQuery([...set], name);
}
export function getShopBaseUrl(location: { origin: string; pathname: string }): string {
	const { origin, pathname } = location;
	return origin + "/" + pathname.split("/")[1];
}
